import { useState } from "react";
import GeneralIndex from "./GeneralIndex";
import NotificationsIndex from "./NotificationsIndex";
import TablesIndex from "./TablesIndex";
import SettingsNavigation from "./SettingsNavigation";

export default function Settings() {
  const [activeSection, setActiveSection] = useState("general");

  const handleNavigate = (sectionId: string) => {
    setActiveSection(sectionId);
  };

  return (
    <div className="flex h-full w-full overflow-hidden p-2">
      <SettingsNavigation
        activeSection={activeSection}
        onNavigate={handleNavigate}
      />
      <div className="settings-scroll w-full overflow-y-scroll">
        <div className="px-4 py-4">
          {activeSection === "general" && <GeneralIndex />}
          {activeSection === "tables" && <TablesIndex />}
          {activeSection === "notifications" && <NotificationsIndex />}
        </div>
      </div>
    </div>
  );
}
